// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"428027cc","1487":"8641a642","4024":"8641a642","6560":"8641a642"}[chunkId] + ".chunk.css";
};